import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import UserRoles from "../user-management/user-roles";
import CollectionType from "../waste-collection/collection-types";
import CollectionCenter from "../waste-collection/collection-centers";
import WasteType from "../waste-collection/waste-types";
import MaterialType from "../waste-collection/material-types";
import MeasureUnit from "../waste-collection/measure-units";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 3),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
}));

const Settings = (props) => {
  const classes = useStyles();
  const { showNotification, handleLoader } = props;
  const initialState = {
    userRole: true,
    collectionType: false,
    collectionCenter: false,
    wasteType: false,
    materialType: false,
    measureUnit: false,
  };
  const [state, setState] = useState(initialState);
  const {
    userRole,
    collectionType,
    collectionCenter,
    wasteType,
    materialType,
    measureUnit,
  } = state;

  return (
    <div>
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs>
            <FormControlLabel
              control={
                <Checkbox
                  checked={userRole ?? false}
                  onChange={(event) => {
                    setState((prevState) => ({
                      ...prevState,
                      userRole: event.target.checked,
                      collectionType: false,
                      collectionCenter: false,
                      wasteType: false,
                      materialType: false,
                      measureUnit: false,
                    }));
                  }}
                  name="userRole"
                  color="primary"
                />
              }
              label="User Roles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={collectionType ?? false}
                  onChange={(event) => {
                    setState((prevState) => ({
                      ...prevState,
                      userRole: false,
                      collectionType: event.target.checked,
                      collectionCenter: false,
                      wasteType: false,
                      materialType: false,
                      measureUnit: false,
                    }));
                  }}
                  name="collectionType"
                  color="primary"
                />
              }
              label="Collection Types"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={collectionCenter ?? false}
                  onChange={(event) => {
                    setState((prevState) => ({
                      ...prevState,
                      userRole: false,
                      collectionType: false,
                      collectionCenter: event.target.checked,
                      wasteType: false,
                      materialType: false,
                      measureUnit: false,
                    }));
                  }}
                  name="collectionCenter"
                  color="primary"
                />
              }
              label="Collection Centers"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={wasteType ?? false}
                  onChange={(event) => {
                    setState((prevState) => ({
                      ...prevState,
                      userRole: false,
                      collectionType: false,
                      collectionCenter: false,
                      wasteType: event.target.checked,
                      materialType: false,
                      measureUnit: false,
                    }));
                  }}
                  name="wasteType"
                  color="primary"
                />
              }
              label="Waste Types"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={materialType ?? false}
                  onChange={(event) => {
                    setState((prevState) => ({
                      ...prevState,
                      userRole: false,
                      collectionType: false,
                      collectionCenter: false,
                      wasteType: false,
                      materialType: event.target.checked,
                      measureUnit: false,
                    }));
                  }}
                  name="materialType"
                  color="primary"
                />
              }
              label="Material Types"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={measureUnit ?? false}
                  onChange={(event) => {
                    setState((prevState) => ({
                      ...prevState,
                      userRole: false,
                      collectionType: false,
                      collectionCenter: false,
                      wasteType: false,
                      materialType: false,
                      measureUnit: event.target.checked,
                    }));
                  }}
                  name="measureUnit"
                  color="primary"
                />
              }
              label="Measure Units"
            />
          </Grid>
        </Grid>
      </Paper>
      {userRole && (
        <UserRoles
          handleLoader={handleLoader}
          showNotification={showNotification}
        />
      )}
      {collectionType && (
        <CollectionType
          handleLoader={handleLoader}
          showNotification={showNotification}
        />
      )}
      {collectionCenter && (
        <CollectionCenter
          handleLoader={handleLoader}
          showNotification={showNotification}
        />
      )}
      {wasteType && (
        <WasteType
          handleLoader={handleLoader}
          showNotification={showNotification}
        />
      )}
      {materialType && (
        <MaterialType
          handleLoader={handleLoader}
          showNotification={showNotification}
        />
      )}
      {measureUnit && (
        <MeasureUnit
          handleLoader={handleLoader}
          showNotification={showNotification}
        />
      )}
    </div>
  );
};
export default Settings;
